function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
import { Command } from 'ckeditor5/src/core';
import { logWarning, toArray } from 'ckeditor5/src/utils';
/**
 * @module image/image/insertimagecommand
 */

/**
 * Insert image command.
 *
 * The command is registered by the {@link module:image/image/imageediting~ImageEditing} plugin as `insertImage`
 * and it is also available via aliased `imageInsert` name.
 *
 * In order to insert an image at the current selection position
 * (according to the {@link module:widget/utils~findOptimalInsertionRange} algorithm),
 * execute the command and specify the image source:
 *
 *		editor.execute( 'insertImage', { source: 'http://url.to.the/image' } );
 *
 * It is also possible to insert multiple images at once:
 *
 *		editor.execute( 'insertImage', {
 *			source:  [
 *				'path/to/image.jpg',
 *				'path/to/other-image.jpg'
 *			]
 *		} );
 *
 * @extends module:core/command~Command
 */

var InsertImageCommand = /*#__PURE__*/function (_Command) {
  _inherits(InsertImageCommand, _Command);

  var _super = _createSuper(InsertImageCommand);

  /**
   * @inheritDoc
   */
  function InsertImageCommand(editor) {
    var _this;

    _classCallCheck(this, InsertImageCommand);

    _this = _super.call(this, editor);
    var configImageInsertType = editor.config.get('image.insert.type');

    if (!editor.plugins.has('ImageBlockEditing')) {
      if (configImageInsertType === 'block') {
        /**
         * The {@link module:image/imageblock~ImageBlock} plugin must be enabled to allow inserting block images. See
         * {@link module:image/imageinsert~ImageInsertConfig#type} to learn more.
         *
         * @error image-block-plugin-required
         */
        logWarning('image-block-plugin-required');
      }
    }

    if (!editor.plugins.has('ImageInlineEditing')) {
      if (configImageInsertType === 'inline') {
        /**
         * The {@link module:image/imageinline~ImageInline} plugin must be enabled to allow inserting inline images. See
         * {@link module:image/imageinsert~ImageInsertConfig#type} to learn more.
         *
         * @error image-inline-plugin-required
         */
        logWarning('image-inline-plugin-required');
      }
    }

    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(InsertImageCommand, [{
    key: "refresh",
    value: function refresh() {
      this.isEnabled = this.editor.plugins.get('ImageUtils').isImageAllowed();
    }
    /**
     * Executes the command.
     *
     * @fires execute
     * @param {Object} options Options for the executed command.
     * @param {String|Array.<String>} options.source The image source or an array of image sources to insert.
     */

  }, {
    key: "execute",
    value: function execute(options) {
      var _this2 = this;

      var sources = toArray(options.source);
      var selection = this.editor.model.document.selection;
      var imageUtils = this.editor.plugins.get('ImageUtils'); // In case of multiple images, each image (starting from the 2nd) will be inserted at a position that
      // follows the previous one. That will move the selection and, to stay on the safe side and make sure
      // all images inherit the same selection attributes, they are collected beforehand.
      //
      // Applying these attributes ensures, for instance, that inserting an (inline) image into a link does
      // not split that link but preserves its continuity.
      //
      // Note: Selection attributes that do not make sense for images will be filtered out by insertImage() anyway.

      var selectionAttributes = Object.fromEntries(selection.getAttributes());
      sources.forEach(function (src, index) {
        var selectedElement = selection.getSelectedElement(); // Inserting of an inline image replace the selected element and make a selection on the inserted image.
        // Therefore inserting multiple inline images requires creating position after each element.

        if (index && selectedElement && imageUtils.isImage(selectedElement)) {
          var position = _this2.editor.model.createPositionAfter(selectedElement);

          imageUtils.insertImage(_objectSpread({
            src: src
          }, selectionAttributes), position);
        } else {
          imageUtils.insertImage(_objectSpread({
            src: src
          }, selectionAttributes));
        }
      });
    }
  }]);

  return InsertImageCommand;
}(Command);

export { InsertImageCommand as default };